import React from "react";
import { string } from "prop-types";

const propTypes = {
  title: string,
  linkClass: string,
  logoSm: string,
  logoLg: string,
};

const siteLogo = (props) => {
  const { logoSm, logoLg, title, linkClass } = props;

  return (
    <div className="site-logo">
      <a
        href="/"
        className={`site-logo__link ${linkClass || ""}`}
        data-gtm-element="site logo"
        data-gtm-link="/"
      >
        <picture className="site-logo__image">
          <source srcSet={logoLg} media="(min-width: 681px)" />
          <img src={logoSm} alt={title || ""} />
        </picture>
      </a>
      {title && <span className="site-logo__title">{title}</span>}
    </div>
  );
};

siteLogo.propTypes = propTypes;
export default siteLogo;
